export const HANDWRITING_FONTS = [
    // ── Original 7 ───────────────────────────────────────────────────────────────
    {
        id: 'homemade-apple',
        label: 'Homemade Apple',
        family: "'Homemade Apple', cursive",
        description: 'Classic messy cursive',
        sampleText: 'Homemade Apple',
    },
    {
        id: 'caveat',
        label: 'Caveat',
        family: "'Caveat', cursive",
        description: 'Clean casual handwriting',
        sampleText: 'Caveat',
    },
    {
        id: 'liu-jian',
        label: 'Liu Jian Mao Cao',
        family: "'Liu Jian Mao Cao', cursive",
        description: 'East Asian brush style',
        sampleText: 'Liu Jian Mao Cao',
    },
    {
        id: 'indie-flower',
        label: 'Indie Flower',
        family: "'Indie Flower', cursive",
        description: 'Bubbly rounded style',
        sampleText: 'Indie Flower',
    },
    {
        id: 'patrick-hand',
        label: 'Patrick Hand',
        family: "'Patrick Hand', cursive",
        description: 'Neat everyday writing',
        sampleText: 'Patrick Hand',
    },
    {
        id: 'permanent-marker',
        label: 'Permanent Marker',
        family: "'Permanent Marker', cursive",
        description: 'Bold thick marker',
        sampleText: 'Permanent Marker',
    },
    {
        id: 'shadows-into-light',
        label: 'Shadows Into Light',
        family: "'Shadows Into Light', cursive",
        description: 'Rushed light strokes',
        sampleText: 'Shadows Into Light',
    },

    // ── 5 New fonts ───────────────────────────────────────────────────────────────
    {
        id: 'dancing-script',
        label: 'Dancing Script',
        family: "'Dancing Script', cursive",
        description: 'Elegant flowing cursive',
        sampleText: 'Dancing Script',
    },
    {
        id: 'pacifico',
        label: 'Pacifico',
        family: "'Pacifico', cursive",
        description: 'Round retro brush',
        sampleText: 'Pacifico',
    },
    {
        id: 'sacramento',
        label: 'Sacramento',
        family: "'Sacramento', cursive",
        description: 'Thin calligraphy script',
        sampleText: 'Sacramento',
    },
    {
        id: 'kalam',
        label: 'Kalam',
        family: "'Kalam', cursive",
        description: 'Natural informal hand',
        sampleText: 'Kalam',
    },
    {
        id: 'amatic-sc',
        label: 'Amatic SC',
        family: "'Amatic SC', cursive",
        description: 'Thin hand-drawn caps',
        sampleText: 'Amatic SC',
    },

    // ── Custom upload ─────────────────────────────────────────────────────────────
    {
        id: 'custom',
        label: 'Your Handwriting',
        family: 'CustomHandwriting, cursive',
        description: 'Upload your own .ttf font',
        sampleText: 'Upload Font ↑',
        isCustom: true,
    },
];
